import { appMode } from '@/lib/app-mode'

/** The host of the harness the build talks to, for display only. */
export function videoDevHarnessHost(videoGenApiUrl: string): string {
  return new URL(videoGenApiUrl).host
}

/**
 * Persistent marker of the Video-Gen-only build (`VITE_APP_MODE=video-dev`), so a screenshot is
 * never mistaken for production. Names the mode and the harness host. Renders nothing otherwise.
 * Fixed in a corner (not in the page flow) so it shows on every route, login included.
 */
export function VideoDevModeBanner({ mode = appMode }: { mode?: typeof appMode }) {
  if (mode.kind !== 'video-dev') return null
  const host = videoDevHarnessHost(mode.videoGenApiUrl)
  return (
    <div
      role="status"
      aria-label="Build mode"
      data-testid="video-dev-mode-banner"
      className="pointer-events-none fixed bottom-2 left-2 z-[90] max-w-[calc(100vw-16px)] truncate rounded-md border border-warning-200 bg-warning-50 px-2 py-1 text-xs font-medium text-warning-800 shadow-sm"
    >
      Video dev build · Video Gen on {host}
    </div>
  )
}
